import React from 'react';

function Government(props: React.SVGAttributes<{}>) {
    return (
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M34.8999 32H6.10018C4.7747 32 3.7002 33.0745 3.7002 34.4V35.6C3.7002 36.9254 4.7747 38 6.10018 38H34.8999C36.2254 38 37.2999 36.9254 37.2999 35.6V34.4C37.2999 33.0745 36.2254 32 34.8999 32Z" fill="#2E2E2E" />
            <path
                d="M10.9001 16.4004H7.30009C6.63735 16.4004 6.1001 16.9376 6.1001 17.6004V29.6003C6.1001 30.263 6.63735 30.8003 7.30009 30.8003H10.9001C11.5628 30.8003 12.1 30.263 12.1 29.6003V17.6004C12.1 16.9376 11.5628 16.4004 10.9001 16.4004Z"
                fill="#2E2E2E"
            />
            <path
                d="M22.2997 16.4004H18.6997C18.037 16.4004 17.4998 16.9376 17.4998 17.6004V29.6003C17.4998 30.263 18.037 30.8003 18.6997 30.8003H22.2997C22.9625 30.8003 23.4997 30.263 23.4997 29.6003V17.6004C23.4997 16.9376 22.9625 16.4004 22.2997 16.4004Z"
                fill="#2E2E2E"
            />
            <path
                d="M33.6999 16.4004H30.0999C29.4372 16.4004 28.8999 16.9376 28.8999 17.6004V29.6003C28.8999 30.263 29.4372 30.8003 30.0999 30.8003H33.6999C34.3626 30.8003 34.8999 30.263 34.8999 29.6003V17.6004C34.8999 16.9376 34.3626 16.4004 33.6999 16.4004Z"
                fill="#2E2E2E"
            />
            <path
                d="M37.9482 12.9906L21.1484 2.19071C20.955 2.0662 20.7298 2 20.4998 2C20.2698 2 20.0446 2.0662 19.8512 2.19071L3.05131 12.9906C2.83318 13.1308 2.66632 13.3378 2.57569 13.5807C2.48507 13.8237 2.47556 14.0894 2.54859 14.3382C2.62162 14.5869 2.77326 14.8054 2.98081 14.9608C3.18836 15.1162 3.44066 15.2002 3.69993 15.2002H37.2997C37.5589 15.2002 37.8112 15.1162 38.0188 14.9608C38.2263 14.8054 38.378 14.587 38.451 14.3382C38.524 14.0894 38.5145 13.8237 38.4239 13.5807C38.3333 13.3378 38.1664 13.1308 37.9482 12.9906Z"
                fill="#2E2E2E"
            />
        </svg>
    );
}

export default Government;
